import type { FC } from 'react';

import { Icon } from '@iconify/react';
import { Divider, ListItem, ListItemText, Typography } from '@mui/material';
import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  divider: {
    backgroundColor: theme.palette.divider,
    height: 2,
    marginLeft: 54,
  },
  icon: {
    height: 40,
    marginLeft: -16,
    marginRight: 16,
    width: 40,
  },
}));

type Props = {
  description: string;
  title: string;
};

export const CardListItemComponent: FC<Props> = ({ description, title }) => {
  const { classes } = useStyles();

  return (
    <>
      <ListItem aria-label={title}>
        <Icon className={classes.icon} icon="material-symbols:info-outline" />
        <ListItemText
          primary={<Typography variant="h5">{description}</Typography>}
          secondary={<Typography>{title}</Typography>}
        />
      </ListItem>
      <Divider className={classes.divider} />
    </>
  );
};
